export const DEFINITIONS_EDITOR_ACTIONS = {
  SelectDefinition: 'SELECT_DEFINITION',
  SelectDataSource: 'SELECT_DATA_SOURCE',
  RunDefinition: 'RUN_DEFINITION',
  RunDefinitionFulfilled: 'RUN_DEFINITION_FULFILLED',

  ShowSQL: 'SHOW_SQL',
  SetView: 'SET_VIEW',

  ToggleVerticalMode: 'TOGGLE_VERTICAL_MODE',
  MaximizeTop: 'MINIMIZE_TOP',
  MinimizeTop: 'MAXIMIZE_TOP',
  MaximizeBottom: 'MINIMIZE_BOTTOM',
  MinimizeBottom: 'MAXIMIZE_BOTTOM',

  SelectSecondaryTab: 'SELECT_SECONDARY_TAB',
  ReportRunDataLoaded: 'REPORT_RUN_DATA_LOADED',
};
